export default {"src":"/_next/static/media/couch.091f47da.svg","height":51,"width":40,"blurWidth":0,"blurHeight":0};